import React from 'react'
import './rain.scss'

export default function Rain() {
  return (
    <div className="rain"></div>
  )
}
